module.exports = __webpack_public_path__ + "static/img/s52.9c29a507.png";